import React from "react";
import { LoadingComponent } from "./LoadingComponent";

/**
 * Handler responsible for showing initial loading gif and in case of any failure
 * show proper error
 *
 * @param props
 */
export const CommonLoadingHandler = (props: any) => {
  if (props.error) {
    // When the loader has errored
    console.error("Error Occurred", props);
    return (
      <div>
        Error! <button onClick={props.retry}>Click to retry</button>
      </div>
    );
  } else if (props.timedOut) {
    // When the loader has taken longer than the timeout
    return (
      <div>
        Taking a long time...{" "}
        <button onClick={props.retry}>Click to retry</button>
      </div>
    );
  } else {
    return <LoadingComponent />;
  }
};

// if (props.error) {
//   console.log("Loading", props);
//   return (
//     <div>
//       <details style={{ whiteSpace: "pre-wrap" }}>
//         What:
//         <span style={{ color: "#d50000" }}>{props.error.toString()}</span>
//       </details>
//     </div>
//   );
// }
